import defer from 'lodash/defer';

import { getCacheItem } from './cacheManager';
import store from './store';

export default ({
  update,
  options: { isStale = true, ...options },
  cacheKey,
}) => {
  const connectedCache = getCacheItem(cacheKey);
  connectedCache.isStale = isStale;
  store.dispatch({ type: `${cacheKey}:SET`, payload: update, options });

  return new Promise((resolve) => {
    defer(() => {
      resolve();
    });
  });
};
